// GENERATED: DO NOT EDIT BY HAND.
//
// Source of truth:  packages/design-tokens/src/
// Regenerate:       node packages/design-tokens/codegen/gen-tokens.mjs
//
// A pre-commit hook and CI fail the build if this file drifts from the source.

/**
 * The standalone playground palette, resolved from the canonical primitives
 * and the depression alpha scale.
 */
export const PLAYGROUND_THEME = {
  brand: '#17cdff', // seagull[400]
  brandInk: '#0a0a0a', // neutralSmoke[950]
  brandStrong: '#02678a', // seagull[800]: the light accent
  canvas: '#fafafa', // neutralSmoke[50]
  surfaceHover: '#f5f5f5', // neutralSmoke[100]
  border: '#e5e5e5', // neutralSmoke[200]
  ink: '#0a0a0a', // neutralSmoke[950]
  inkMuted: '#535353', // neutralSmoke[600]: the light foregroundTertiary
  scrim: 'rgba(10, 10, 10, 0.45)', // neutralSmoke[950] at depression[2]
  scrimSoft: 'rgba(10, 10, 10, 0.15)', // neutralSmoke[950] at depression[0]
} as const
